import Brightness from '@mui/icons-material/Brightness1';
import { Box, Tooltip } from '@mui/material';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { TypographyStyledGlobal, colors, fontWeight, fontSize } from '../../../../../../theme';
import { ColorSwatchInterface } from '../../../../../ColorSwatch/colorSwatch';
import { ColorContainer, ColorScaleBox, ColorScalesBox } from '../../styled';
import { ReactComponent as SettingsIcon } from '../../../../../../assets/settings/settings.svg';

interface ColorScalesProps {
    selectedColorShades?: ColorSwatchInterface,
    handleSelectColorShades: (colorScale: ColorSwatchInterface) => void
    userColorScales: ColorSwatchInterface[]
}

const ColorScales: FC<ColorScalesProps> = ({ selectedColorShades, handleSelectColorShades, userColorScales }) => {
    const { t } = useTranslation('dashboard');

    return (
        <>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <TypographyStyledGlobal
                    color={colors.grey100}
                    margin='30px 0 8px 0'
                    size='1.5em'
                    weight={fontWeight.semiBold}
                >
                    {t('colorScale.title')}
                </TypographyStyledGlobal>
                <Tooltip
                    componentsProps={{
                        tooltip: {
                            sx: {
                                bgcolor: colors.grey100,
                                borderRadius: '4px',
                                color: colors.grey000,
                                fontSize: fontSize.sm,
                                fontWeight: fontWeight.semiRegular,
                                maxWidth: 360,
                                padding: '6px 10px',
                                '& .MuiTooltip-arrow': { color: colors.grey100 },
                            },
                        },
                    }}
                    placement="top"
                    title={t('colorScale.settingsTooltip')}
                    arrow
                >
                    <Link style={{ display: 'flex', alignItems: 'center' }} to="/settings#color-swatches">
                        <SettingsIcon />
                    </Link>
                </Tooltip>
            </Box>
            <TypographyStyledGlobal
                color={colors.grey300}
                margin='0 0 10px 0'
                size={fontSize.sm}
                weight={fontWeight.regular}
            >
                {t('colorScale.subtitle')}
            </TypographyStyledGlobal>
            <ColorScalesBox>
                {userColorScales.map((colorScale) => (
                    <ColorScaleBox key={`color-scale-box-${colorScale.id}`} isSelected={selectedColorShades && selectedColorShades.id === colorScale.id} onClick={() => handleSelectColorShades(colorScale)}>
                        <TypographyStyledGlobal
                            color={colors.grey200}
                            margin='8px 0 8px 0'
                            size={fontSize.sm}
                            textAlign='center'
                            weight={fontWeight.regular}
                            width='max-content'
                        >
                            { colorScale.label }
                        </TypographyStyledGlobal>
                        <ColorContainer>
                            {colorScale.colors.map((color: string, index: number) => (
                                <Brightness
                                    /* eslint-disable */
                                    key={`color-scale-brightness-${colorScale.id}-${index}`}
                                    /* eslint-enable */
                                    sx={{ color }}
                                />
                            ))}
                        </ColorContainer>
                    </ColorScaleBox>
                ))}
            </ColorScalesBox>
        </>
    );
};

export default ColorScales;
